import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersComponent } from './users/users.component';
import { StoresComponent } from './stores/stores.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RetailHqComponent } from './retail-hq/retail-hq.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { AssetLibraryModule } from '../../modules/asset-library/asset-library.module';
import { ActiveUsersComponent } from './active-users/active-users.component';
import { DomainWhitelistComponent } from './domain-whitelist/domain-whitelist.component';
import { TagInputModule } from 'ngx-chips';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PendingUsersComponent } from './pending-users/pending-users.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PipeUtilModule } from '../pipes/pipe-util/pipe-util.module';
import { DeleteModule } from '../../common/components/delete/delete.module';

@NgModule({
  declarations: [UsersComponent,StoresComponent,
    RetailHqComponent,
    ActiveUsersComponent,
    DomainWhitelistComponent,
    PendingUsersComponent],
  imports: [
    CommonModule, 
    FormsModule, 
    ReactiveFormsModule, 
    ColorPickerModule,
    NgbModule,AssetLibraryModule,
    TagInputModule,
    BrowserAnimationsModule,
    NgSelectModule,
    PipeUtilModule,
    DeleteModule
  ]
 
})
export class UsersModule { }
